import WIDGETS from './widgets';

export default {
	name: 'navbar_kind',
	spacing: 0,
	sx: { width: '100%' },
	widgets: [{ content: WIDGETS.KIND_NAVBAR, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 }],
};
